

export function formatCurrency(amount) {
  if (isNaN(amount)) {
    return '$';
  }

  const number = (new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD'
  })).format(amount).split('.')[0];
  if (number.startsWith('-')) {
    return '($' + number.substr(2) + ')';
  }
  return number;
};
